(() => {
  'use strict';
  const KEY='aecbookstore_wishlist';
  const MAX=80;
  const MB=window.MB||{};
  const q=(s,r=document)=>r.querySelector(s);
  const qa=(s,r=document)=>[...r.querySelectorAll(s)];
  const escape=MB.escape||((v='')=>String(v).replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c])));
  const money=MB.money||((c)=>`$${((Number(c)||0)/100).toFixed(2)}`);
  let cache=new Map();
  let lastFocus=null;

  const read=()=>{
    try{
      const raw=JSON.parse(localStorage.getItem(KEY)||'[]');
      return Array.isArray(raw)?raw.filter(Boolean).map(String):[];
    }catch{return[];}
  };
  const write=(list)=>{try{localStorage.setItem(KEY,JSON.stringify([...new Set(list)].slice(0,MAX)));}catch{}};
  const contains=(handle)=>read().includes(String(handle));

  function sync(){
    const list=read();
    qa('[data-wishlist-handle]').forEach(btn=>{
      const on=list.includes(String(btn.dataset.wishlistHandle));
      btn.classList.toggle('is-active',on);
      btn.setAttribute('aria-pressed',String(on));
      const label=btn.querySelector('[data-wishlist-label-text]');
      if(label) label.textContent=on?'Saved to wishlist':'Save to wishlist';
      const glyph=btn.querySelector('[data-wishlist-glyph]');
      if(glyph) glyph.textContent=on?'♥':'♡';
      if(btn.matches('.book-card__wishlist, .product-gallery__wishlist')){
        btn.title=on?'Remove from wishlist':'Save to wishlist';
        btn.setAttribute('aria-label',on?'Remove from wishlist':'Save to wishlist');
      }
    });
    qa('[data-wishlist-count]').forEach(el=>{
      el.textContent=list.length;
      el.hidden=list.length===0;
    });
    document.dispatchEvent(new CustomEvent('aecbookstore:wishlist:changed',{detail:{handles:list,count:list.length}}));
  }

  function toast(message){
    const el=q('#AECBookstoreToast');
    if(!el)return;
    el.innerHTML=`<span class="wishlist-toast__check" aria-hidden="true">✓</span><span>${escape(message)}</span><button type="button" data-wishlist-open>View saved</button>`;
    el.classList.add('show','is-visible','wishlist-toast');
    clearTimeout(MB._toast);
    MB._toast=setTimeout(()=>el.classList.remove('show','is-visible'),3200);
  }

  async function product(handle){
    if(cache.has(handle))return cache.get(handle);
    try{
      const r=await fetch(`/products/${encodeURIComponent(handle)}.js`,{headers:{Accept:'application/json'}});
      if(!r.ok)throw new Error('not found');
      const p=await r.json();cache.set(handle,p);return p;
    }catch{return null;}
  }

  function availableVariant(p){
    if(!p?.variants?.length)return null;
    return p.variants.find(v=>v.available)||p.variants[0]||null;
  }

  function itemMarkup(p){
    const v=availableVariant(p);
    const image=p.featured_image||p.images?.[0]||'';
    const variant=v&&v.title&&v.title!=='Default Title'?`<small>${escape(v.title)}</small>`:'';
    return `<article class="wishlist-item" data-wishlist-item="${escape(p.handle)}">
      <a class="wishlist-item__media" href="${escape(p.url)}">${image?`<img src="${escape(image)}" alt="${escape(p.title)}" loading="lazy">`:''}</a>
      <div class="wishlist-item__body">
        <div class="wishlist-item__top"><a class="wishlist-item__title" href="${escape(p.url)}">${escape(p.title)}</a><button type="button" class="wishlist-item__remove" data-wishlist-handle="${escape(p.handle)}" aria-label="Remove ${escape(p.title)} from wishlist">×</button></div>
        ${p.vendor?`<div class="wishlist-item__vendor">${escape(p.vendor)}</div>`:''}
        ${variant}
        <strong class="wishlist-item__price">${money(v?.price??p.price)}</strong>
        <div class="wishlist-item__actions">
          ${v?.available?`<button class="button button--secondary" type="button" data-wishlist-add data-variant-id="${v.id}">Add to cart</button>`:`<a class="button button--secondary" href="${escape(p.url)}">View book</a>`}
        </div>
      </div>
    </article>`;
  }

  async function renderDrawer(){
    const shell=q('[data-wishlist-shell]');if(!shell)return;
    const items=q('[data-wishlist-items]',shell),empty=q('[data-wishlist-empty]',shell),loading=q('[data-wishlist-loading]',shell);
    const handles=read();
    if(items)items.innerHTML='';
    if(empty)empty.hidden=true;
    if(!handles.length){if(loading)loading.hidden=true;if(empty)empty.hidden=false;return;}
    if(loading)loading.hidden=false;
    const products=(await Promise.all(handles.map(product))).filter(Boolean);
    if(loading)loading.hidden=true;
    if(!products.length){if(empty)empty.hidden=false;return;}
    if(items)items.innerHTML=products.map(itemMarkup).join('');
  }

  async function openDrawer(opener){
    const shell=q('[data-wishlist-shell]');if(!shell)return;
    lastFocus=opener||document.activeElement;
    shell.hidden=false;
    requestAnimationFrame(()=>shell.classList.add('is-open'));
    document.body.classList.add('wishlist-open');
    await renderDrawer();
    q('[data-wishlist-close]',shell)?.focus();
  }
  function closeDrawer(){
    const shell=q('[data-wishlist-shell]');if(!shell||shell.hidden)return;
    shell.classList.remove('is-open');
    document.body.classList.remove('wishlist-open');
    setTimeout(()=>{shell.hidden=true;lastFocus?.focus?.();},210);
  }

  function openAccountSheet(opener){
    const shell=q('[data-account-sheet]');if(!shell)return;
    lastFocus=opener||document.activeElement;
    shell.hidden=false;
    requestAnimationFrame(()=>shell.classList.add('is-open'));
    document.body.classList.add('account-sheet-open');
  }
  function closeAccountSheet(){
    const shell=q('[data-account-sheet]');if(!shell||shell.hidden)return;
    shell.classList.remove('is-open');
    document.body.classList.remove('account-sheet-open');
    setTimeout(()=>{shell.hidden=true;},210);
  }

  async function addVariant(button){
    const id=Number(button.dataset.variantId);if(!id)return;
    const old=button.textContent;button.disabled=true;button.textContent='Adding…';
    try{
      const r=await fetch(window.AECBookstore?.routes?.cartAdd||'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
      const data=await r.json();
      if(!r.ok)throw new Error(data.description||'Could not add to cart');
      document.dispatchEvent(new CustomEvent('aecbookstore:cart:refresh',{detail:{open:true}}));
      MB.announce?.('Added to cart');
    }catch(err){MB.announce?.(err.message||'Could not add to cart');}
    finally{button.disabled=false;button.textContent=old;}
  }

  document.addEventListener('click',async e=>{
    const accountOpen=e.target.closest('[data-account-sheet-open]');
    if(accountOpen){e.preventDefault();openAccountSheet(accountOpen);return;}
    if(e.target.closest('[data-account-sheet-close]')){closeAccountSheet();}

    const open=e.target.closest('[data-wishlist-open]');
    if(open){e.preventDefault();closeAccountSheet();openDrawer(open);return;}
    if(e.target.closest('[data-wishlist-close]')){e.preventDefault();closeDrawer();return;}

    const add=e.target.closest('[data-wishlist-add]');
    if(add){e.preventDefault();await addVariant(add);return;}

    const btn=e.target.closest('[data-wishlist-handle]');
    if(!btn)return;
    e.preventDefault();e.stopPropagation();
    const handle=String(btn.dataset.wishlistHandle||'');if(!handle)return;
    let list=read();
    const was=list.includes(handle);
    list=was?list.filter(x=>x!==handle):[handle,...list.filter(x=>x!==handle)];
    write(list);sync();
    if(q('[data-wishlist-shell]')?.classList.contains('is-open'))await renderDrawer();
    toast(was?'Removed from wishlist':'Saved to wishlist');
  });

  document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeDrawer();closeAccountSheet();}});
  window.addEventListener('storage',e=>{if(e.key===KEY){sync();if(q('[data-wishlist-shell]')?.classList.contains('is-open'))renderDrawer();}});

  window.AECBookstoreWishlist={read,contains,sync,open:openDrawer,close:closeDrawer,render:renderDrawer};
  document.addEventListener('DOMContentLoaded',sync);
  sync();
})();
